module.exports = __webpack_public_path__ + "img/sec3_slide1.87aa7d57.jpg";